import { render, staticRenderFns } from "./goods-item.vue?vue&type=template&id=6d5555db&scoped=true&"
import script from "./goods-item.js?vue&type=script&lang=js&"
export * from "./goods-item.js?vue&type=script&lang=js&"
import style0 from "./goods-item.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./goods-item.vue?vue&type=style&index=1&id=6d5555db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5555db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d5555db')) {
      api.createRecord('6d5555db', component.options)
    } else {
      api.reload('6d5555db', component.options)
    }
    module.hot.accept("./goods-item.vue?vue&type=template&id=6d5555db&scoped=true&", function () {
      api.rerender('6d5555db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cart/components/goods-item/goods-item.vue"
export default component.exports